import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { QuestionListItem } from "service/question";
import { SortableHandle } from "react-sortable-hoc";
import { htmlToPlain, replaceImgTag } from "utils/common";
import { isTrue } from "../../../../../../../../service/service";

interface ListItemProps {
    index: number;
    data: QuestionListItem;
    selected: boolean;
    handleClick: () => void;
}

export default function ListItem({
    index,
    data,
    selected,
    handleClick
}: ListItemProps) {
    const Handle = SortableHandle(() => (
        <span
            className={classNames(style.handle, { [style.active]: selected })}
        />
    ));

    function onClick() {
        window.scrollTo(0, 0);
        handleClick();
    }

    return (
        <div
            className={classNames(style.root, selected ? style.selected : "")}
            onClick={onClick}>
            {index + 1}.
            <span className={style.info}>
                （{data.queTypeName}）
                {isTrue(data.requiredFlag) && (
                    <span className="required_overflow" />
                )}
            </span>
            <div
                className={style.option}
                dangerouslySetInnerHTML={{
                    __html: htmlToPlain(data?.contentText, replaceImgTag)
                }}
            />
            <Handle />
        </div>
    );
}
